const accessibilityProvider = ({
	tabIndex = 0,
	name = "",
	role = "",
	level = "",
	title = "",
	disableTabIndex = false,
} = {}) => {
	const attributes = {};
	if (!disableTabIndex) {
		attributes["tabIndex"] = tabIndex;
	}
	if (title) {
		attributes["title"] = title;
	}
	if (name) {
		attributes["aria-label"] = name;
	}
	if (role) {
		attributes["role"] = role;
	}
	if (level) {
		attributes["aria-level"] = level;
	}
	return attributes;
};

export default accessibilityProvider;
